// UserForm Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

import app from '../../../app.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import Input from '../input/input.jsx'
import InputTag from '../input_tag/input_tag.jsx'
import Select from '../select/select.jsx'
import Checkbox from '../checkbox/checkbox.jsx'
import Typo from '../../typography/typo/typo.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import UserRateCardForm from '../../../setting/user_ratecard/user_ratecard_form/user_ratecard_form.jsx'
import ScheduleList from '../../user/schedule_list/schedule_list.jsx'

class UserForm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      stepIndex: 1,
      firstName: '',
      lastName: '',
      language: props.defaultLang,
      email: '',
      functions: '',
      rateCards: [],
      roles: [],
      roleType: 'Standard user',
      bUpdatedStep2: false,
      skills: [],
      dataDate: null,
      hasOneOwner: false,
      startDate: null,
      endDate: null
    }

    this.data = {
      user: null,
      languages: [
        { label: 'setting.userForm.optionNederlands', value: 'NL' },
        { label: 'setting.userForm.optionEnglish', value: 'EN' },
        { label: 'setting.userForm.optionDeutsch', value: 'DE' }
      ],
      scheduleOptions: [],
      schedules: []
    }

    this._references = {
      inputFirstName: React.createRef(),
      inputLastName: React.createRef(),
      inputEmail: React.createRef(),
      inputRate: React.createRef(),
      selectLanguage: React.createRef(),
      refUserDatePicker: React.createRef(),
      rateForm: React.createRef()
    }

    this._validateStep = false
  }

  static get propTypes () {
    return {
      onSubmit: PropTypes.func,
      validateRole: PropTypes.func,
      onClose: PropTypes.func,
      skillSuggestions: PropTypes.array,
      getSchedule: PropTypes.func,
      onDayTimerChange: PropTypes.func,
      onClickSetting: PropTypes.func,
      onAddSchedule: PropTypes.func,
      defaultLang: PropTypes.string,
      prefixCurrency: PropTypes.string,
      showLanguageDropdown: PropTypes.bool,
      onShowError: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      onSubmit: null,
      validateRole: null,
      onClose: null,
      skillSuggestions: [],
      getSchedule: null,
      onDayTimerChange: null,
      onClickSetting: null,
      onAddSchedule: null,
      defaultLang: 'NL',
      prefixCurrency: '',
      country: '',
      showLanguageDropdown: true,
      onShowError: null
    }
  }

  show (user, hasOneOwner, scheduleOptions) {
    FabButtonManager.setVisible(false)
    this.data.user = user

    const stateObj = { active: true, hasOneOwner: hasOneOwner }
    if (user !== undefined && user) {
      const skills = []
      if (user.skills && user.skills.length > 0) {
        user.skills.map((skill, idx) => {
          skills.push({ id: idx + 1, text: skill.toLowerCase() })
        })
      }

      stateObj.firstName = user.firstName
      stateObj.lastName = user.lastName
      stateObj.language = user.language
      stateObj.email = user.email
      stateObj.functions = user.functions
      stateObj.rateCards = user.rateCards
      stateObj.roleType = user.roleType
      stateObj.roles = user.roles
      stateObj.skills = skills
    } else {
      stateObj.rateCards = [
        {
          date: new Date(),
          rate: 0,
          costRate: 0
        }
      ]
    }

    this.data.scheduleOptions = []
    if (scheduleOptions && scheduleOptions.length > 0) {
      this.data.scheduleOptions = scheduleOptions
    }

    this.setState(stateObj)
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.data.project = null
    this.data.schedules = []
    this.data.scheduleOptions = []
    this.setState({
      active: false,
      stepIndex: 1,
      firstName: '',
      lastName: '',
      language: this.props.defaultLang,
      email: '',
      functions: '',
      rateCards: [],
      roles: [],
      skills: [],
      hasOneOwner: false,
      roleType: 'Standard user'
    })

    if (this._references.inputFirstName.current) {
      this._references.inputFirstName.current.clearError()
    }

    if (this._references.inputLastName.current) {
      this._references.inputLastName.current.clearError()
    }

    if (this._references.inputEmail.current) {
      this._references.inputEmail.current.clearError()
    }

    if (this._references.inputRate.current) {
      this._references.inputRate.current.clearError()
    }

    if (this._references.selectLanguage.current) {
      this._references.selectLanguage.current.clearError()
    }
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._onKeyDown)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._onKeyDown)
  }

  componentDidUpdate (prevProps, prevState) {
    const currStep = this.state.stepIndex
    if (
      this.state.active &&
      prevState.stepIndex !== currStep &&
      this._validateStep
    ) {
      this._validateStep = false

      if (currStep === 1) {
        this._validateStep1()
      }
    }
  }

  _onKeyDown = (ev) => {
    if (this.state.active && this.state.stepIndex !== 4 && ev.keyCode === 13) {
      this._handleSubmit(ev)
    } else if (this.state.active && ev.keyCode === 27) {
      this.hide()
    }
  };

  render () {
    const _wizCls = classnames('wizard-form', {
      active: this.state.active
    })

    return (
      <div className={_wizCls}>
        <form
          className='form'
          method='post'
          onSubmit={this._handleSubmit.bind(this)}
        >
          <div className='wfrmstepinfo'>
            <IconButton
              icon='wizard-close'
              className='modal wizard-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
            {this._renderStepsInfo()}
            {this._renderStepsAction()}
          </div>
          <div className='wfrmstepcontent'>
            {this._renderStepsContent()}
            <div className='stepsaction'>
              <IconButton
                className='wizard-submit'
                icon='common-success-tick'
                title='setting.userForm.tipSave'
                canHover={false}
                type='primary'
                size='big'
                tooltip='setting.userForm.tipSaveClose'
                tooltipPosition='top'
                onClick={this._handleSubmit.bind(this)}
              />
            </div>
          </div>
        </form>
      </div>
    )
  }

  /* Event handlers */
  _validateStep1 () {
    const { firstName, lastName, email, rateCards, language } = this.state
    let noErrors = 0

    if (
      (this._references.inputFirstName.current &&
        !this._references.inputFirstName.current.validate()) ||
      !firstName
    ) {
      noErrors++
    }
    if (
      (this._references.inputLastName.current &&
        !this._references.inputLastName.current.validate()) ||
      !lastName
    ) {
      noErrors++
    }
    if (
      (this._references.inputEmail.current &&
        !this._references.inputEmail.current.validate()) ||
      !email
    ) {
      noErrors++
    }
    if (rateCards.length === 0 || !this._checkRateCardValidate()) {
      noErrors++

      if (this.props.onShowError) {
        this.props.onShowError('setting.userForm.errorInvalidRatecard')
      }
    }
    if (
      (this._references.selectLanguage.current &&
        !this._references.selectLanguage.current.validate()) ||
      !language
    ) {
      noErrors++
    }

    return !(noErrors > 0)
  }

  _checkRateCardValidate () {
    const rateCards = this.state.rateCards

    let noErr = 0
    rateCards.forEach((rateCard) => {
      if (!rateCard.rate || !rateCard.date || isNaN(rateCard.costRate)) {
        noErr++
      }
    })

    if (this._references.rateForm.current) {
      this._references.rateForm.current.validate()
    }

    return !(noErr > 0)
  }

  _handleSubmit (ev) {
    ev.preventDefault()

    let noErrors = 0
    if (!this._validateStep1()) {
      noErrors++

      this._validateStep = true
      this.setState({ stepIndex: 1 })
    }

    if (noErrors === 0) {
      const skills = []

      if (this.state.skills && this.state.skills.length > 0) {
        this.state.skills.map((skill) => {
          skills.push(skill.text)
        })
      }

      // Remove empty ratecards
      const rateCards = []
      this.state.rateCards.map((item) => {
        if (item.date) {
          item.rate = item.rate || 0
          item.costRate = item.costRate || 0
          rateCards.push(item)
        }
      })

      const data = {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email: this.state.email,
        functions: this.state.functions,
        rateCards: rateCards,
        status: this.data.user ? this.data.user.status : 'invited',
        skills: skills
      }
      const timezone = this.data.user ? this.data.user.timezone : ''

      const isNewUser = !this.data.user || !this.data.user.id
      if (this.props.showLanguageDropdown || isNewUser) {
        data.language = this.state.language
      }

      if (!this.props.validateRole) {
        return
      }

      const userTeamId = isNewUser ? null : this.data.user.id
      const userId = isNewUser ? null : this.data.user.userId
      this.props.validateRole(userTeamId, (_bValid) => {
        this.props.onSubmit(
          data,
          userTeamId,
          userId,
          this.state.roleType,
          this.state.roles,
          this.data.schedules,
          this.data.scheduleOptions,
          timezone
        )
      })
    }
  }

  _onChangeInput (name, value) {
    this.setState({ [name]: value })
  }

  _onChangeCheckbox (name, value, bChecked) {
    if (name === 'roles') {
      let roles = this.state.roles ? this.state.roles : []
      if (bChecked && _.indexOf(roles, value) < 0) {
        roles.push(value)
      } else {
        roles = _.remove(this.state.roles, (role) => role !== value)
      }
      this.setState({
        roles: roles,
        roleType: roles && roles.length > 0 ? 'Full user' : 'Standard user'
      })
    }
  }

  _handleStepChange (step, e) {
    e.preventDefault()
    const stateObj = {
      stepIndex: step
    }

    if (step === 1) {
      stateObj.bUpdatedStep2 = true
    }

    this.setState(stateObj)
  }

  _onClickClose (ev) {
    ev.preventDefault()
    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  _getValidateClass (step) {
    return classnames('stepinfo', {
      active: this.state.stepIndex === step,
      complete: this._getIsCompleted(step),
      error: this._getHasError(step)
    })
  }

  _getIsCompleted (step) {
    let bComplete = false
    if (step === 1) {
      bComplete =
        this.state.firstName &&
        this.state.lastName &&
        this.state.language &&
        this.state.email &&
        this.state.rateCards.length > 0
    } else if (step === 2) {
      bComplete =
        this.state.roles && this.state.roles.length > 0 && this.state.roleType
    } else if (step === 3) {
      bComplete = this.data.scheduleOptions.length > 0
    } else if (step === 4) {
      bComplete = this.state.skills.length > 0
    }

    return bComplete
  }

  _getHasError (step) {
    let bError = false
    if (step === 1) {
      bError =
        !this.state.firstName ||
        !this.state.lastName ||
        !this.state.language ||
        !this.state.email ||
        this.state.rateCards.length <= 0
    }
    return bError
  }

  _handleSkillChange (step, e) {
    e.preventDefault()
    const stateObj = {
      stepIndex: step
    }
    this.setState(stateObj)
  }

  _onUpdateSkills (skills) {
    this.setState({ skills: skills })
  }

  _getSchedule (userId, fromDate, toDate, callback) {
    callback(this.data.schedules)
  }

  _onDayTimerChange (userId, dayObj, timeAvailable) {
    dayObj.timeAvailable = timeAvailable
    this.setState({ dataDate: new Date() })
  }

  /* Private functions */
  _renderStepsContent () {
    return (
      <div className='stepscontent'>
        {this._renderStep1()}
        {this._renderStep2()}
        {this._renderStep3()}
        {this._renderStep4()}
      </div>
    )
  }

  _renderStepsInfo () {
    let userInfo = IntlUtil.convertMessage(
      'setting.userForm.stepUserDetailsInfo'
    )
    if (this.state.firstName && this.state.lastName) {
      userInfo = `${this.state.firstName} ${this.state.lastName}`
    }

    let rightInfo = IntlUtil.convertMessage(
      'setting.userForm.stepUserRightsInfo'
    )
    if (this.state.roles && this.state.roles.length > 0) {
      const roleArray = this.state.roles
      rightInfo = ''

      for (var i = 0; i < roleArray.length; i++) {
        rightInfo += '- ' + roleArray[i] + '<br />'
      }
    }

    let skillInfo = IntlUtil.convertMessage(
      'setting.userForm.stepUserSkillInfo'
    )
    if (this.state.skills && this.state.skills.length > 0) {
      const skills = []
      this.state.skills.map((skill) => {
        skills.push(skill.text)
      })

      skillInfo = ''

      for (var j = 0; j < skills.length; j++) {
        skillInfo += '- ' + skills[j] + '<br />'
      }
    }

    const scheduleInfo = this._getScheduleInfo()
    const statusTick = <i className='icon icon-list-tick' />

    return (
      <div className='stepsinfo'>
        <div
          className={this._getValidateClass(1)}
          onClick={this._handleStepChange.bind(this, 1)}
        >
          <div className='stepstatus'>
            {this._getIsCompleted(1) ? statusTick : ''}
          </div>
          <div className='stepitem'>
            <h4>
              <IntlMessage ident='setting.userForm.stepUserDetails' />
            </h4>
            <div className='info'>{userInfo}</div>
          </div>
        </div>
        <div
          className={this._getValidateClass(2)}
          onClick={this._handleStepChange.bind(this, 2)}
        >
          <div className='stepstatus'>
            {this._getIsCompleted(2) ? statusTick : ''}
          </div>
          <div className='stepitem'>
            <h4>
              <IntlMessage ident='setting.userForm.stepUserRights' />
            </h4>
            <div
              className='info'
              dangerouslySetInnerHTML={{ __html: rightInfo }}
            />
          </div>
        </div>
        <div
          className={this._getValidateClass(3)}
          onClick={this._handleSkillChange.bind(this, 3)}
        >
          <div className='stepstatus'>
            {this._getIsCompleted(3) ? statusTick : ''}
          </div>
          <div className='stepitem'>
            <h4>
              <IntlMessage ident='setting.userForm.stepUserSchedule' />
            </h4>
            <div className='info'>{scheduleInfo}</div>
          </div>
        </div>
        <div
          className={this._getValidateClass(4)}
          onClick={this._handleSkillChange.bind(this, 4)}
        >
          <div className='stepstatus'>
            {this._getIsCompleted(4) ? statusTick : ''}
          </div>
          <div className='stepitem'>
            <h4>
              <IntlMessage ident='setting.userForm.stepUserSkills' />
            </h4>
            <div
              className='info'
              dangerouslySetInnerHTML={{ __html: skillInfo }}
            />
          </div>
        </div>
      </div>
    )
  }

  _renderStepsAction () {
    if (!this.state.active) {
      return ''
    }

    let prevStepClass = 'wizard wizardprev disabled'
    let nextStepClass = 'wizard wizardnext disabled'

    if (this.state.stepIndex > 1) {
      prevStepClass = 'wizard wizardprev'
    }

    if (this.state.stepIndex < 4) {
      nextStepClass = 'wizard wizardnext'
    }

    return (
      <div className='stepsaction'>
        <IconButton
          className={prevStepClass}
          icon='common-previousstep'
          title='setting.userForm.tipPreviousStep'
          canHover={false}
          size='big'
          tooltip='setting.userForm.tipPreviousStep'
          tooltipPosition='top'
          onClick={this._handleStepChange.bind(this, this.state.stepIndex - 1)}
        />
        <IconButton
          className={nextStepClass}
          icon='common-nextstep'
          title='setting.userForm.tipNextStep'
          canHover={false}
          size='big'
          tooltip='setting.userForm.tipNextStep'
          tooltipPosition='top'
          onClick={this._handleStepChange.bind(this, this.state.stepIndex + 1)}
        />
        <IconButton
          className='wizard-submit'
          icon='common-success-tick'
          title='setting.userForm.tipSave'
          canHover={false}
          type='primary'
          size='big'
          onClick={this._handleSubmit.bind(this)}
        />
      </div>
    )
  }

  _renderStep1 () {
    if (this.state.stepIndex !== 1) {
      return ''
    }

    return (
      <div className='wizardstep'>
        <div className='form-layout'>
          <div className='layoutcol'>
            <div className='formsection'>
              <div className='formheader'>
                <h2>
                  <IntlMessage ident='setting.userForm.userDetailTitle' />
                </h2>
              </div>
              <div className='formrow'>
                <div className='formcol'>
                  <Input
                    type='text'
                    name='firstName'
                    label='setting.userForm.firstNamePlaceholder'
                    value={this.state.firstName}
                    size={10}
                    maxLength={128}
                    validations={['required']}
                    onChange={this._onChangeInput.bind(this, 'firstName')}
                    ref={this._references.inputFirstName}
                  />
                </div>
              </div>
              <div className='formrow'>
                <div className='formcol'>
                  <Input
                    type='text'
                    name='lastName'
                    label='setting.userForm.lastNamePlaceholder'
                    value={this.state.lastName}
                    size={10}
                    maxLength={128}
                    validations={['required']}
                    onChange={this._onChangeInput.bind(this, 'lastName')}
                    ref={this._references.inputLastName}
                  />
                </div>
              </div>
              {this.props.showLanguageDropdown && (
                <div className='formrow'>
                  <div className='formcol'>
                    <Select
                      options={this.data.languages}
                      name='language'
                      label='setting.userForm.languagePlaceholder'
                      multilingualOptions
                      ref={this._references.selectLanguage}
                      className='form-dropdown'
                      onChange={this._onChangeInput.bind(this, 'language')}
                      value={this.state.language}
                    />
                  </div>
                </div>
              )}
              <div className='formrow'>
                <div className='formcol'>
                  <Input
                    type='text'
                    name='email'
                    label='setting.userForm.emailPlaceholder'
                    value={this.state.email}
                    size={10}
                    maxLength={128}
                    validations={['required']}
                    onChange={this._onChangeInput.bind(this, 'email')}
                    ref={this._references.inputEmail}
                    disabled={
                      !!(this.data.user &&
                      this.data.user.id &&
                      this.data.user.userId)
                    }
                  />
                </div>
              </div>
              <div className='formrow'>
                <div className='formcol'>
                  <Input
                    type='text'
                    name='functions'
                    label='setting.userForm.functionPlaceholder'
                    value={this.state.functions}
                    size={10}
                    maxLength={128}
                    styleDotted
                    onChange={this._onChangeInput.bind(this, 'functions')}
                  />
                </div>
              </div>
            </div>
          </div>
          <UserRateCardForm
            ref={this._references.rateForm}
            items={this.state.rateCards}
            prefixCurrency={this.props.prefixCurrency}
            onChange={this._onChangeRatecards.bind(this)}
          />
        </div>
      </div>
    )
  }

  _onChangeRatecards (items) {
    this.setState({ rateCards: items })
  }

  refreshSchedules (scheduleOptions) {
    if (scheduleOptions && scheduleOptions.length > 0) {
      this.data.scheduleOptions = scheduleOptions
      this.setState({ dataDate: new Date() })
    }
  }

  _renderStep2 () {
    if (this.state.stepIndex !== 2) {
      return ''
    }

    const ownerClass = (this.state.hasOneOwner && !app.isSupportUser())
      ? 'checkitem disable'
      : 'checkitem'

    return (
      <div className='wizardstep'>
        <div className='form-layout'>
          <div className='layoutcol'>
            <div className='formsection'>
              <div className='formheader'>
                <h2>
                  <IntlMessage ident='setting.userForm.userRightsTitle' />
                </h2>
              </div>
              <div className='formrow'>
                <Typo className='profile'>
                  <p>
                    <IntlMessage ident='setting.userForm.userRightsInfo' />
                  </p>
                </Typo>
              </div>
            </div>

            <div className='formsplitter' />

            <div className='formsection'>
              <div className='formheader'>
                <h2 className='alt'>
                  <IntlMessage ident='setting.userForm.userRightsFormTitle' />
                </h2>
              </div>
              <div className='formrow'>
                <div className='formcol'>
                  <div className='checkitem'>
                    <Checkbox
                      icon='common'
                      checked={
                        _.indexOf(this.state.roles, 'Project Management') >= 0
                      }
                      onChange={this._onChangeCheckbox.bind(
                        this,
                        'roles',
                        'Project Management'
                      )}
                    />
                    <div className='desc'>
                      <span className='title'>
                        <IntlMessage ident='setting.userForm.projectManagement' />
                      </span>
                      <span className='info'>
                        <IntlMessage ident='setting.userForm.projectManagementTitleInfo' />
                      </span>
                    </div>
                  </div>
                  <div className='checkitem'>
                    <Checkbox
                      icon='common'
                      checked={_.indexOf(this.state.roles, 'Finance') >= 0}
                      onChange={this._onChangeCheckbox.bind(
                        this,
                        'roles',
                        'Finance'
                      )}
                    />
                    <div className='desc'>
                      <span className='title'>
                        <IntlMessage ident='setting.userForm.finance' />
                      </span>
                      <span className='info'>
                        <IntlMessage ident='setting.userForm.financeInfo' />
                      </span>
                    </div>
                  </div>
                  <div className={ownerClass}>
                    <Checkbox
                      icon='common'
                      checked={
                        _.indexOf(this.state.roles, 'Account owner') >= 0
                      }
                      disabled={this.state.hasOneOwner && !app.isSupportUser()}
                      onChange={this._onChangeCheckbox.bind(
                        this,
                        'roles',
                        'Account owner'
                      )}
                    />
                    <div className='desc'>
                      <span className='title'>
                        <IntlMessage ident='setting.userForm.accountOwner' />
                      </span>
                      <span className='info'>
                        <IntlMessage ident='setting.userForm.accountOwnerInfo' />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='formsplitter' />

            <div className='formsection'>
              <div className='formrow'>
                <div className='formcol'>
                  <div className='roleinfo'>
                    <div className='type'>
                      <IntlMessage ident='setting.userForm.userType' />
                    </div>
                    <div className='desc'>
                      <span className='title'>{this.state.roleType}</span>
                      <span className='info'>
                        <IntlMessage ident='setting.userForm.userTypeInfo' />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _renderStep3 () {
    if (this.state.stepIndex !== 3) {
      return ''
    }

    return (
      <div className='wizardstep wizardstep_schedule'>
        <div className='form-layout'>
          <div className='layoutcol'>
            <div className='formsection'>
              <div className='formheader'>
                <h2>
                  <IntlMessage ident='setting.userForm.stepScheduleFormTitle' />
                </h2>
              </div>
              <div className='formrow'>
                <div className='formcol'>
                  <ScheduleList
                    showheader={false}
                    scheduleOptions={this.data.scheduleOptions}
                    onAddSchedule={this._onAddSchedule.bind(this)}
                    onClickSetting={this._onClickSetting.bind(this)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _onClickSetting (scheduleOption) {
    if (this.props.onClickSetting) {
      this.props.onClickSetting(scheduleOption)
    }
  }

  _onAddSchedule () {
    if (this.props.onAddSchedule) {
      this.props.onAddSchedule(this.data.scheduleOptions)
    }
  }

  _renderStep4 () {
    if (this.state.stepIndex !== 4) {
      return ''
    }

    return (
      <div className='wizardstep'>
        <div className='form-layout'>
          <div className='layoutcol'>
            <div className='formsection'>
              <div className='formheader'>
                <h2>
                  <IntlMessage ident='setting.userForm.stepSkillsFormTitle' />
                </h2>
              </div>
              <div className='formrow'>
                <div className='formcol'>
                  <InputTag
                    placeholder='setting.userForm.addSkill'
                    tags={this.state.skills}
                    tagSuggestions={this.props.skillSuggestions}
                    onUpdateTags={this._onUpdateSkills.bind(this)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _onChangeDate (name, value) {
    this.setState({ [name]: value })
  }

  _onFocus (_name, _value) {
    if (this._references.refUserDatePicker.current) {
      this._references.refUserDatePicker.current.showDatePicker()
    }
  }

  _onValidateDate (endDate) {
    if (this.state.startDate) {
      return !endDate.isBefore(new Date(this.state.startDate))
    }

    return ''
  }

  _getScheduleInfo () {
    let scheduleInfo = IntlUtil.convertMessage(
      'setting.userForm.stepUserScheduleInfo'
    )
    if (this.data.schedules && this.data.schedules.length > 0) {
      let currWeekTotalTime = 0
      let nextWeekTotalTime = 0

      this.data.schedules.map((schedule, idx) => {
        if (idx < 7) {
          currWeekTotalTime += schedule.timeAvailable
        } else {
          nextWeekTotalTime += schedule.timeAvailable
        }
      })

      scheduleInfo = `${parseInt(currWeekTotalTime / 60)} / ${parseInt(
        nextWeekTotalTime / 60
      )}`
    }

    return scheduleInfo
  }
}

export default UserForm
